module.exports = __webpack_public_path__ + "assets/img/meeting-2026-link-reconvented.950221a6.jpg";